import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const PREFIX = 'xxllncFilterBar'

const classes = {
  root: `${PREFIX}-root`,
}

const Root = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    'display': 'flex',
    'flexWrap': 'wrap',
    'alignItems': 'center',
    'gap': theme.spacing(1),
    // Stop flex children from stretching — every filter sets its own width.
    '& > .MuiFormControl-root, & > .MuiTextField-root': {
      flex: '0 0 auto',
    },
    '& .MuiInputBase-root': {
      backgroundColor: '#fff',
    },
  },
}))

/**
 * Compact horizontal filter strip for data pages.
 *
 * Children are laid out left-to-right with a tight gap; on narrow viewports
 * they wrap to a second row. Designed for use inside :class:`DataPageLayout`
 * ``controls`` slot so the filter row stays one or two lines tall and the
 * data area underneath gets the rest of the viewport.
 */
const FilterBar: FC<Props> = ({ children }) => (
  <Root className={classes.root}>{children}</Root>
)

export default FilterBar
